import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
): { frequency: number; service: string; earnings: number }[] | null => {
  //   console.log(res.data);
  const newData = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const { frequency, service_name, earnings } = res.data.data[i];
      newData.push({
        frequency,
        service: service_name,
        earnings,
      });
    }

    return newData;
  }

  return null;
};

export const useGetFrequentServices = ({
  // isEnabled = true,
  dateRange,
  startDate,
  endDate,
  limit = 10,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.frequentServicesWithFilters({
      dateRange,
      startDate,
      endDate,
      limit,
    }),
    queryFn: () => {
      return api.get("analytics/services/frequent", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          limit,
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Frequent services]", res);
      handleErrors(res, "query");
    },
  });
};
